export const MCP_SERVERS_PATH_NAME = 'mcp-servers';
